import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatCounterService {
  unreadChatCount: Subject<any> = new Subject<any>();
  constructor() { }
}
